const hasValue = (value) => value !== undefined && value !== null && value !== ''

const normalizeObject = (value) => {
  if (!value || typeof value !== 'object' || Array.isArray(value)) return {}
  return value
}

export function mergeUserInfo(current, latest) {
  const currentInfo = normalizeObject(current)
  const latestInfo = normalizeObject(latest)
  const merged = {
    ...currentInfo,
    ...latestInfo,
  }

  if (!hasValue(latestInfo.token) && hasValue(currentInfo.token)) {
    merged.token = currentInfo.token
  }

  return merged
}
